import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { supportedLanguages, SupportedLanguage } from '@/i18n/config';

interface LanguageWrapperProps {
  children: React.ReactNode;
}

export const LanguageWrapper: React.FC<LanguageWrapperProps> = ({ children }) => {
  const location = useLocation();
  const pathParts = location.pathname.split('/').filter(Boolean);
  const urlLang = pathParts[0] as SupportedLanguage;

  // If we're at root, redirect based on browser language
  if (location.pathname === '/') {
    const browserLang = navigator.language.split('-')[0] as SupportedLanguage;
    const detectedLang = supportedLanguages.includes(browserLang) ? browserLang : 'en';
    return <Navigate to={`/${detectedLang}/`} replace />;
  }

  // If first path segment isn't a supported language, redirect with language prefix
  if (!supportedLanguages.includes(urlLang)) {
    const storedLang = localStorage.getItem('preferredLanguage') as SupportedLanguage;
    const browserLang = navigator.language.split('-')[0] as SupportedLanguage;
    const detectedLang = storedLang && supportedLanguages.includes(storedLang) 
      ? storedLang 
      : supportedLanguages.includes(browserLang) 
        ? browserLang 
        : 'en';
    
    return <Navigate to={`/${detectedLang}${location.pathname}`} replace />;
  }

  return <>{children}</>;
};
